import HttpService from './HttpService';

const ECargoApi = HttpService('/api/ecargoapi/');
const doPost = (action, data) => ECargoApi.post(action, data);
const doGet = (url) => ECargoApi.get(url);
const doDelete = (url) => ECargoApi.delete(url);

export default {
  getCargoInformation(siteId, voyageNo) {
    const queryString = `siteId=${siteId}&voyageNo=${voyageNo}`;
    const apiAction = 'GetEcargoVoyage';
    const fullUrl = queryString ? `${apiAction}?${queryString}` : apiAction;
    return doGet(fullUrl);
  },

  updateCargoOffshoreLiftTime(siteId, lines) {
    const queryString=`siteId=${siteId}`
    const apiAction = 'UpdateCargoOffshoreLiftTime'
    const fullUrl = queryString ? `${apiAction}?${queryString}` : apiAction;
    return doPost(fullUrl, lines);
  }
};
